import { c, s, t } from '../val.config';

const eventSeriesSchema = s.object({
  title: s.string(),
  active: s.boolean(),
});
export type EventSeries = t.inferSchema<typeof eventSeriesSchema>;
// NOTE: not a record since we have to implement the actual logic for rendering the different types of series
const schema = s.object({
  party: eventSeriesSchema,
  presentation: eventSeriesSchema,
});

export default c.define('/settings/eventSeries.val.ts', schema, {
  party: {
    title: 'Fest',
    active: true,
  },
  presentation: {
    title: 'Kjøregår',
    active: true,
  },
});
